import { Statistic, Table, Tabs} from 'antd'

import React, {useState, useEffect} from 'react'
import ClaimTableDiscord from './ClaimTableDiscord';



function ClaimTable() {
    const [result, setResult] = useState([])
    const [sum, setSums] = useState({sumDogenano: 0, sumDogecoin: 0})
    const [loading, setLoading] = useState(false)

    const columns = [
      {
        title: 'Date claim',
        dataIndex: 'claimDate',
        key: 'claimDate',
        render: (d) => {
          d = d['$date']
          return new Date(d).toLocaleDateString() + " " + new Date(d).toLocaleTimeString()
        }
      },
      {
        title: 'XDG Claimed',
        dataIndex: 'dogenanoAmount',
        key: 'dogenanoAmount',
      },
      
      {
        title: 'DogeNano Hash',
        dataIndex: 'hashSent',
        key: 'hashSent',
        render: (r) => <a href={'https://explorer.dogenano.io/block/'+r}>View</a>
      },
      {
        title: 'Dogecoin Address',
        dataIndex: 'dogecoinAddress',
        key: 'dogecoinAddress',
      },
      {
        title: 'DogeNano Address',
        dataIndex: 'dogenanoAddress',
        key: 'dogenanoAddress',
      },
   
     
      {
        title: 'Message signed',
        dataIndex: 'message',
        key: 'message',
      },
      {
        title: 'Signature',
        dataIndex: 'signature',
        key: 'signature',
      },
    ];

    useEffect(() => {
      setLoading(true)
        import ('./distribution-data/dogecoin.claims.json').then((r) => {
          const data = r.default
          // sort by date
          data.sort((a,b) => new Date(b.claimDate['$date']) - new Date(a.claimDate['$date']))
          setResult(data)
          setLoading(false)
        })
        
    }, [])
    
  return (
    <div>
      <b>Total:</b> {result.reduce((a, b) => a + b.dogenanoAmount, 0).toLocaleString('en-US')} XDG<br/>

      <Table 
      size='small'
      loading={loading} scroll={{x: true}} dataSource={result} columns={columns} pagination={{defaultPageSize: 5}}></Table>
    </div>
  )
}

export default ClaimTable